import styled from 'styled-components';
import { Flex, Box, BoxProps } from 'components/ui';
import randomIcon from 'img/random.svg';
import futuraSpec from 'utils/futuraSpec.json';
import undoIcon from 'img/undo.svg';
import redoIcon from 'img/redo.svg';

interface RemixShuffleProps {
  values: any;
  disabled?: boolean;
  setValues: (any) => void;
  push: (any) => void;
  canUndo: boolean;
  canRedo: boolean;
  onUndo: () => void;
  onRedo: () => void;
}

interface SbuttonProps {
  children: JSX.Element;
  parentDisabled?: boolean;
  disabled?: boolean;
  enabled?: boolean;
}

const Wrapper = styled(Box)<any>`
  cursor: pointer;
  pointer-events: ${props => (props.disabled || props.parentDisabled) ? 'none' : 'auto'};
  opacity: ${props => props.parentDisabled ? 1 : props.disabled ? .3 : 1}; 
`;

const SButton = ({ children, parentDisabled, disabled, ...props }:SbuttonProps & BoxProps) => (
  <Wrapper
    backgroundColor="black"
    fontWeight="100"
    borderRadius="3px"
    parentDisabled={parentDisabled}
    disabled={disabled}
    py={1}
    px={2}
    mr={2}
    {...props}
  >
    { children }
  </Wrapper>
);

const RemixShuffleOptions = ({ values, setValues, canUndo, canRedo, onUndo, onRedo, push, disabled }:RemixShuffleProps) => {
  const randomize = () => {
    let clips = {};
    for (let layer of futuraSpec.layers) {
      for (let section of futuraSpec.sections) {
        const attrKey = `${section.name} ${layer.name}`;
        const r = Math.random();
        clips[attrKey] = r < 0.5 ? 'A' : 'B';
      }
    }
    const newValues = {...values, ...clips};
    push(newValues);
    setValues(newValues);
  }

  return (
    <Flex>
      <SButton>
        <Flex alignCenter>
          <img src={randomIcon} alt="Random" width="16px" />
          <Box ml={2} onClick={randomize}>Random</Box>
        </Flex>
      </SButton>
      <SButton disabled={!canUndo} parentDisabled={disabled} onClick={onUndo}>
        <Flex alignCenter>
          <img src={undoIcon} alt="Undo" width="16px" />
          <Box ml={2}>Undo</Box>
        </Flex>
      </SButton>
      <SButton disabled={!canRedo} parentDisabled={disabled} onClick={onRedo}>
        <Flex alignCenter>
          <img src={redoIcon} alt="Redo" width="16px" />
          <Box ml={2}>Redo</Box>
        </Flex>
      </SButton>
    </Flex>
  )
}

export default RemixShuffleOptions;
